<template>
    <div class="video-modal mt-0" v-for="(video,videoKey,index) in ($route.name == 'WalletDeposit' ? walletConfig.deposit_video : walletConfig.withdrawal_video)" :key="index">
        <template v-if="video">
            <div class="thm-heading">
                <h3>How To {{$route.name == 'WalletDeposit' ? 'Deposit ' : 'Withdraw '}}({{ videoKey }})</h3>
            </div>
            <div class="video-sec">
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe :src="video" :title="videoKey"
                        frameborder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
	name: "WalletInstructionVideos",
    inject: ['walletConfig'],
}
</script>